import React from 'react';
import { Helmet } from 'react-helmet-async';

const About = () => {
    return(
        <>
        <Helmet>
            <title>About Alessandro Iovino - Professional Photographer</title>
            <meta name="description" content="Learn about Alessandro Iovino, an award-winning photographer specializing in commercial, editorial, and fine art photography." />
            <meta property="og:title" content="About Alessandro Iovino" />
            <meta property="og:description" content="Learn about Alessandro Iovino's photography career, background, and artistic vision." />
            <link rel="canonical" href="https://alessandroiovino.com/about" />
        </Helmet>
        <div className="picture-gallery">
            <div className="photo-column">
                <div className="solo-item">
                    <h1 className="sr-only">About Alessandro Iovino</h1>
                    <div className="text">
                    I must have been 4 or 5 years old. We were all living together under the same roof—my mum and dad, my brother and sisters, the dogs, and my nanny Caterina and her husband, Lucio. That is the best memory I have.
                    <br />
                    <br />
                    After that, I remember the fights, the court battles, the few days spent with my father, and the lies. Since then, I’ve always felt like something was being hidden from me. I’ve never known the full story about my family, and I still don’t.
                    <br />
                    <br />
                    I spent most of my life with one person: my mother. 
                    <br />
                    <br />
                    Much of who I am today is because of her. And because of her, I had to leave and prove myself.
                    <br />
                    <br />
                    Not seeing my father caused me a lot of pain. 
                    <br />
                    <br />
                    Dad had many women. 
                    <br />
                    <br />
                    I erased two years of my life—those years when I hated him and didn’t even want to see him, not even from the kitchen window.
                    <br />
                    <br />
                    The people I've surrounded me with helped me to understand what kind of truth I needed; photography helped me to keep track of it.
                    Today what makes me happy is knowing that whatever I do, is done with certain honesty. 
                    Today I feel I'm in a much better place than I was, I feel I don't have to run anymore.
                    <br />
                    <br />
                    I miss home.
                    </div>
                    <br />
                    <br />
                    <div className="cv">
                        <a href="/files/CV_Alessandro iovino_2024.pdf" download="CV_Alessandro_Iovino_2024.pdf">Alessandro Iovino CV</a>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

export default About;